import { lazyWithRetry } from 'components/lazyUtil.js'

const PaymentPage = lazyWithRetry(() => import('../../payments/booking/bookPayment.js'))

// IMPORTANT //
// In Future: whenever new route path is added ensure to update "validPaths" in /server/validRoutes.js
const routes = [
  {
    path: '/payments/book/:reservationID',
    component: PaymentPage,
    private: true,
  },
]

export default routes
